<div class="modal-template wide-modal unfixed-button-modal transfer-between-accounts">
  <form [formGroup]="transferForm">
    <div class="modal-container">
      <div class="modal-header">
        <div class="title-text">
          <span class="j2-icon-transfer"></span>
          {{ ('transfer.new' | translate) }}
        </div>
        <div class="close-modal" (click)="closeModal()">
          <span class="j-icon-cross"></span>
        </div>
      </div>
      <div class="modal-body">
        <div class="content-container">
          <div class="input-container" [ngClass]="{ 'invalid-validation': f.get(['companyBankAccountFrom']).errors && submittedForm }">
            <label>{{ 'transfer.fromBankAccount' | translate }}<span class="required-validation">*</span></label>
            <ejs-combobox
              #comboBoxBankAccountFrom
              [enabled]="false"
              [allowFiltering]="true"
              [allowCustom]="allowCurrent"
              [dataSource]="[data?.companyBankAccountFrom]"
              formControlName="companyBankAccountFrom"
              [fields]="{ text: 'accountName', value: 'id' }"
              [placeholder]="'common.select' | translate"
              [noRecordsTemplate]="'noRecord' | translate"
              [valueTemplate]='valueTemplate'
            >
            <ng-template #valueTemplate="" let-data="">
              <span class='value'>{{data.accountNumber}} ({{data.accountName}})</span>
            </ng-template>
            </ejs-combobox>
          </div>
          <div class="input-container" [ngClass]="{ 'invalid-validation': f.get(['companyBankAccountTo']).errors && submittedForm }">
            <label>{{ 'transfer.toBankAccount' | translate }}<span class="required-validation">*</span></label>
            <ejs-combobox
              #comboBoxBankAccountTo
              [enabled]="!data?.transfer?.id"
              [allowFiltering]="true"
              [allowCustom]="allowCurrent"
              [dataSource]="bankAccounts"
              formControlName="companyBankAccountTo"
              [fields]="{ text: 'accountName', value: 'id' }"
              [placeholder]="'common.select' | translate"
              [noRecordsTemplate]="'noRecord' | translate"
              [valueTemplate]='valueTemplate'
            >
              <ng-template #itemTemplate="" let-data="">
                <div class="template-bank-account">
                  <span class="info">
                    <span class='name'> {{data.accountName}}</span>
                    <span class='number'>{{data.accountNumber}}</span>
                  </span>
                  <span class="balance">
                    <span>{{data.balance}}</span>
                  </span>
                </div>
              </ng-template>
              <ng-template #valueTemplate="" let-data="">
                <span class='value'>{{data.accountNumber}} ({{data.accountName}})</span>
              </ng-template>
            </ejs-combobox>
          </div>
            <div class="input-container" [ngClass]="{ 'invalid-validation': f.get(['payAt']).errors && submittedForm }">
              <label class="">{{ 'payment.date' | translate }}<span class="required-validation">*</span></label>
              <div class="datepicker-container">
                <ejs-datepicker
                  id="startDate"
                  formControlName="payAt"
                  [format]="dateFormat"
                  [locale]="locale$ | async"
                  [placeholder]="'common.select' | translate"
                >
                </ejs-datepicker>
              </div>
            </div>

            <div class="input-container amount-with-currency" [ngClass]="{ 'invalid-validation': f.get(['amount']).errors && submittedForm }">
              <label class="">{{ 'transfer.amount' | translate }}<span class="required-validation">*</span></label>
              <div class="text-select-field default-size">
                <input formControlName="amount" min="0" placeholder="{{'enterAmountTransfer' | translate}}" (keypress)="fixAmount($event)" />
                <span class="currency">{{data?.companyBankAccountFrom?.currency?.code}}</span>
              </div>
            </div>
            <div class="current-rate" *ngIf="data?.transfer">
              <span>
                {{'transfer.transferCurrency' | translate}} | 1 {{data?.transfer?.companyBankAccountFrom?.currency?.code}} =
                <span class="rate">
                  {{transferForm.get('rateCompanyBankAccountTo').value}}
                  {{data?.transfer?.companyBankAccountTo?.currency?.code}}
                </span>
              </span>
              <span class="j-icon-edit" (click)="changeRate()"></span>
            </div>
          <div class="input-container description-input">
            <label>{{ 'transfer.description' | translate }}</label>
            <textarea formControlName="description" placeholder="{{ 'common.writeHere' | translate }}"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button-container">
          <button class="btn-template btn-blue dropdown-button"  (click)="saveTransfer()">
            {{ 'button.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
